import LxcError from "~/core/models/LxcError.class";
import { SectorAssignationsEntityType } from "~/modules/sector/models/SectorAssignationsEntityType.enum";
import type { SectorAttachDetachPayload } from "~/modules/sector/models/SectorAttachDetachPayload.interface";
import type { SectorItemActionResult } from "~/modules/sector/models/SectorItemActionResult.interface";
import sectorsService from "~/modules/sector/services/sectors.service";
import { SectorResource } from "~/types";

export function useAttachDetachEntitiesToSector(organizationCode?: number) {
  const error: Ref<LxcError | undefined> = ref();
  const results: Ref<SectorItemActionResult[]> = ref([]);
  const isLoading: Ref<boolean> = ref(false);

  async function attachDetachEntities(
    sectorCode: number,
    entityType: SectorResource,
    attachDetachPayload: SectorAttachDetachPayload,
  ): Promise<void> {
    error.value = undefined;
    results.value = [];
    isLoading.value = true;

    if (organizationCode) {
      let response;
      switch (entityType) {
        case SectorResource.DTWINS:
          response = await sectorsService.attachDetachEntitiesToSector(
            organizationCode,
            sectorCode,
            attachDetachPayload,
            SectorAssignationsEntityType.DTWINS,
          );
          break;
        case SectorResource.USER:
          response = await sectorsService.attachDetachEntitiesToSector(
            organizationCode,
            sectorCode,
            attachDetachPayload,
            SectorAssignationsEntityType.USERS,
          );
          break;
        case SectorResource.USER_GROUP:
          response = await sectorsService.attachDetachEntitiesToSector(
            organizationCode,
            sectorCode,
            attachDetachPayload,
            SectorAssignationsEntityType.USER_GROUPS,
          );
          break;
      }

      if (LxcError.check(response)) {
        error.value = response;
      } else {
        buildResults(attachDetachPayload);
      }
    } else {
      throw new Error("Organization code is undefined");
    }
    isLoading.value = false;
  }

  function buildResults(attachDetachPayload: SectorAttachDetachPayload) {
    if (attachDetachPayload.assign && attachDetachPayload.assign?.length > 0) {
      results.value = attachDetachPayload.assign.map((itemId: string) => {
        return {
          success: true,
          name: itemId,
        };
      });
    } else {
      results.value =
        attachDetachPayload.unassign?.map((itemId: string) => {
          return {
            success: true,
            name: itemId,
          };
        }) ?? [];
    }
  }

  return {
    error,
    results,
    attachDetachEntities,
    isLoading,
  };
}
